import * as React from 'react';

import { CartServiceProps } from '../../types';
import BaggageSummary from '../../../ServiceSummary/services/BaggageSummary';

const Animal: React.FC<CartServiceProps> = ({ onServiceDelete }) => {
	return (
		<BaggageSummary onServiceDelete={onServiceDelete} isAnimalBaggage>
			{content => <>{content}</>}
		</BaggageSummary>
	);
};

export default Animal;
